import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withKeys as _withKeys, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "form"
};
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = { class: "form-title" };
const _hoisted_4 = { class: "form-menu" };
const _hoisted_5 = { class: "float-end" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* HOISTED */);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Save", -1 /* HOISTED */);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Close", -1 /* HOISTED */);
const _hoisted_10 = { class: "form-contents" };
const _hoisted_11 = { class: "row" };
const _hoisted_12 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_13 = { class: "clearfix" };
const _hoisted_14 = { class: "card bg-white mb-3" };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("div", { class: "card-header" }, [
    /*#__PURE__*/ _createElementVNode("h5", { class: "m-0" }, "Location")
], -1 /* HOISTED */);
const _hoisted_16 = { class: "card-body" };
const _hoisted_17 = { class: "clearfix" };
const _hoisted_18 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("label", null, "Company *", -1 /* HOISTED */);
const _hoisted_20 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("label", null, "System *", -1 /* HOISTED */);
const _hoisted_22 = { class: "clearfix" };
const _hoisted_23 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("label", null, "String", -1 /* HOISTED */);
const _hoisted_25 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("label", null, "Block", -1 /* HOISTED */);
const _hoisted_27 = {
    key: 0,
    class: "text-danger"
};
const _hoisted_28 = { key: 1 };
const _hoisted_29 = { key: 2 };
const _hoisted_30 = { key: 0 };
const _hoisted_31 = { class: "d-flex align-items-center w-100" };
const _hoisted_32 = {
    key: 0,
    class: "multiselect__single flex-grow-1"
};
const _hoisted_33 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
const _hoisted_34 = [
    _hoisted_33
];
const _hoisted_35 = { class: "font-weight-normal" };
const _hoisted_36 = /*#__PURE__*/ _createElementVNode("small", { class: "text-muted" }, "Enter block numbers (e.g. 1-3,5,7-9)", -1 /* HOISTED */);
const _hoisted_37 = { class: "card bg-white mb-3" };
const _hoisted_38 = /*#__PURE__*/ _createElementVNode("div", { class: "card-header" }, [
    /*#__PURE__*/ _createElementVNode("h5", { class: "m-0" }, "Details")
], -1 /* HOISTED */);
const _hoisted_39 = { class: "card-body" };
const _hoisted_40 = { class: "clearfix" };
const _hoisted_41 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_42 = /*#__PURE__*/ _createElementVNode("label", null, "Description *", -1 /* HOISTED */);
const _hoisted_43 = { class: "position-relative" };
const _hoisted_44 = {
    key: 0,
    class: "invalid-feedback"
};
const _hoisted_45 = {
    key: 1,
    class: "suggestions-dropdown"
};
const _hoisted_46 = {
    key: 0,
    class: "suggestions-list"
};
const _hoisted_47 = ["onMousedown", "onMouseover"];
const _hoisted_48 = {
    key: 1,
    class: "no-suggestions"
};
const _hoisted_49 = { class: "clearfix" };
const _hoisted_50 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_51 = /*#__PURE__*/ _createElementVNode("label", null, "Assignee", -1 /* HOISTED */);
const _hoisted_52 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_53 = /*#__PURE__*/ _createElementVNode("label", null, "Severity", -1 /* HOISTED */);
const _hoisted_54 = { class: "clearfix" };
const _hoisted_55 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_56 = /*#__PURE__*/ _createElementVNode("label", null, "Action", -1 /* HOISTED */);
const _hoisted_57 = { class: "issue-action-options" };
const _hoisted_58 = {
    key: 0,
    class: "issue-action-task-input ms-4"
};
const _hoisted_59 = { class: "position-relative" };
const _hoisted_60 = {
    key: 0,
    class: "invalid-feedback"
};
const _hoisted_61 = {
    key: 1,
    class: "suggestions-dropdown"
};
const _hoisted_62 = {
    key: 0,
    class: "suggestions-list"
};
const _hoisted_63 = ["onMousedown", "onMouseover"];
const _hoisted_64 = {
    key: 1,
    class: "no-suggestions"
};
const _hoisted_65 = {
    key: 1,
    class: "issue-action-date-input ms-4"
};
const _hoisted_66 = /*#__PURE__*/ _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
    /*#__PURE__*/ _createElementVNode("button", {
        type: "button",
        class: "btn btn-default",
        "data-toggle": "flatpickr"
    }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calendar" })
    ])
], -1 /* HOISTED */);
const _hoisted_67 = { class: "clearfix" };
const _hoisted_68 = { class: "col-xs-12 col-sm-12 bottom10" };
const _hoisted_69 = /*#__PURE__*/ _createElementVNode("label", null, "Notes", -1 /* HOISTED */);
const _hoisted_70 = { class: "notes-editor" };
const _hoisted_71 = {
    key: 0,
    class: "invalid-feedback"
};
const _hoisted_72 = { class: "notes-toolbar" };
const _hoisted_73 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-link" }, null, -1 /* HOISTED */);
const _hoisted_74 = {
    key: 0,
    class: "col-xs-12 col-sm-12 bottom10"
};
const _hoisted_75 = { class: "checkbox-wrapper" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_form_radio = _resolveComponent("b-form-radio");
    const _component_flat_pickr = _resolveComponent("flat-pickr");
    const _component_b_input_group_append = _resolveComponent("b-input-group-append");
    const _component_b_input_group = _resolveComponent("b-input-group");
    const _component_RichTextareaVue = _resolveComponent("RichTextareaVue");
    const _component_b_form_group = _resolveComponent("b-form-group");
    const _component_b_form = _resolveComponent("b-form");
    const _component_b_modal = _resolveComponent("b-modal");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    return (_ctx.loaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("h2", {
                        class: _normalizeClass({ 'red-text': _ctx.model.whenDeleted })
                    }, _toDisplayString(_ctx.pageTitle), 3 /* TEXT, CLASS */)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_b_button, {
                            type: "button",
                            variant: "primary",
                            onClick: _ctx.save,
                            disabled: _ctx.working
                        }, {
                            default: _withCtx(() => [
                                _hoisted_6,
                                _hoisted_7
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick", "disabled"]),
                        _createTextVNode(),
                        _createVNode(_component_b_button, {
                            type: "button",
                            variant: "secondary",
                            onClick: _ctx.cancel,
                            disabled: _ctx.working
                        }, {
                            default: _withCtx(() => [
                                _hoisted_8,
                                _hoisted_9
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick", "disabled"])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                            _createCommentVNode(" Location Group "),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                    _hoisted_15,
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_16, [
                                        _createElementVNode("div", _hoisted_17, [
                                            _withDirectives(_createElementVNode("div", _hoisted_18, [
                                                _hoisted_19,
                                                _createTextVNode(),
                                                _createVNode(_component_multiselect, {
                                                    modelValue: _ctx.company,
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.company) = $event)),
                                                    name: "company",
                                                    options: _ctx.companies,
                                                    "track-by": "value",
                                                    label: "text",
                                                    searchable: true,
                                                    "show-labels": false,
                                                    placeholder: "Select company",
                                                    class: "multiselect-small",
                                                    disabled: !_ctx.isNew
                                                }, null, 8 /* PROPS */, ["modelValue", "options", "disabled"])
                                            ], 512 /* NEED_PATCH */), [
                                                [_vShow, _ctx.companies && _ctx.companies.length > 1]
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_20, [
                                                _hoisted_21,
                                                _createTextVNode(),
                                                _createVNode(_component_multiselect, {
                                                    modelValue: _ctx.system,
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.system) = $event)),
                                                    name: "system",
                                                    options: _ctx.filteredSystems,
                                                    "track-by": "value",
                                                    label: "text",
                                                    searchable: true,
                                                    "show-labels": false,
                                                    placeholder: "Select system",
                                                    class: "multiselect-small"
                                                }, null, 8 /* PROPS */, ["modelValue", "options"])
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_22, [
                                            _createElementVNode("div", _hoisted_23, [
                                                _hoisted_24,
                                                _createTextVNode(),
                                                _createVNode(_component_multiselect, {
                                                    modelValue: _ctx.stringItem,
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.stringItem) = $event)),
                                                    name: "string",
                                                    options: _ctx.strings,
                                                    "track-by": "value",
                                                    label: "text",
                                                    searchable: true,
                                                    "show-labels": false,
                                                    placeholder: "Select string (optional)",
                                                    class: "multiselect-small"
                                                }, null, 8 /* PROPS */, ["modelValue", "options"])
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_25, [
                                                _hoisted_26,
                                                _createTextVNode(),
                                                _createVNode(_component_multiselect, {
                                                    options: _ctx.blocks,
                                                    name: "block",
                                                    "track-by": "value",
                                                    label: "text",
                                                    searchable: true,
                                                    "show-labels": false,
                                                    multiple: true,
                                                    "preserve-search": true,
                                                    "close-on-select": false,
                                                    "internal-search": false,
                                                    "filter-results": false,
                                                    placeholder: "",
                                                    class: "multiselect-small",
                                                    onSearchChange: _ctx.handleBlockInput
                                                }, {
                                                    noResult: _withCtx(() => [
                                                        (_ctx.blockSelectionError)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.blockSelectionError), 1 /* TEXT */))
                                                            : (_ctx.isBlockSelectionInputValid)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_28, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tPress enter to select blocks " + _toDisplayString(_ctx.blockSelectionInput), 1 /* TEXT */))
                                                                : (_openBlock(), _createElementBlock("span", _hoisted_29, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t"))
                                                    ]),
                                                    placeholder: _withCtx(() => [
                                                        (!_ctx.numberOfSelectedBlocks)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_30, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tNone selected\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t"))
                                                            : _createCommentVNode("v-if", true)
                                                    ]),
                                                    selection: _withCtx(({ search, isOpen }) => [
                                                        _createElementVNode("div", _hoisted_31, [
                                                            (_ctx.numberOfSelectedBlocks && !isOpen)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.blockSelectionText), 1 /* TEXT */))
                                                                : _createCommentVNode("v-if", true),
                                                            _createTextVNode(),
                                                            (_ctx.numberOfSelectedBlocks && !isOpen)
                                                                ? (_openBlock(), _createElementBlock("button", {
                                                                    key: 1,
                                                                    type: "button",
                                                                    class: "btn btn-link btn-sm p-0 ms-2",
                                                                    onClick: _cache[3] || (_cache[3] = _withModifiers(
                                                                    //@ts-ignore
                                                                    (...args) => (_ctx.clearBlockSelection && _ctx.clearBlockSelection(...args)), ["stop", "prevent"]))
                                                                }, _hoisted_34))
                                                                : _createCommentVNode("v-if", true)
                                                        ])
                                                    ]),
                                                    option: _withCtx((props) => [
                                                        _createElementVNode("div", null, [
                                                            _createVNode(_component_b_form_checkbox, {
                                                                id: 'block-' + props.option.value,
                                                                modelValue: props.option.selected,
                                                                "onUpdate:modelValue": ($event) => ((props.option.selected) = $event)
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createElementVNode("label", _hoisted_35, _toDisplayString(props.option.text), 1 /* TEXT */)
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "modelValue", "onUpdate:modelValue"])
                                                        ])
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["options", "onSearchChange"]),
                                                _createTextVNode(),
                                                _hoisted_36
                                            ])
                                        ])
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            _createCommentVNode(" Description field moved after Location "),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_37, [
                                _hoisted_38,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_39, [
                                    _createElementVNode("div", _hoisted_40, [
                                        _createElementVNode("div", _hoisted_41, [
                                            _hoisted_42,
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_43, [
                                                _createVNode(_component_b_form_input, _mergeProps(_ctx.descriptionVal, {
                                                    name: "description",
                                                    type: "text",
                                                    modelValue: _ctx.description.input,
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.description.input) = $event)),
                                                    class: ['form-control', _ctx.errors && _ctx.errors.description && _ctx.attemptedSave ? 'is-invalid' : ''],
                                                    placeholder: "Enter description",
                                                    maxlength: "250",
                                                    onInput: _cache[5] || (_cache[5] = (e) => _ctx.handleInput(e, _ctx.description, _ctx.fieldConfigs.description)),
                                                    onKeydown: [
                                                        _cache[6] || (_cache[6] = _withKeys(_withModifiers(() => _ctx.handleEnterKey(_ctx.description, _ctx.fieldConfigs.description), ["prevent"]), ["enter"])),
                                                        _cache[7] || (_cache[7] = _withKeys(() => _ctx.clearSuggestions(_ctx.description), ["tab"])),
                                                        _cache[8] || (_cache[8] = _withKeys(_withModifiers(() => _ctx.navigateSuggestions(-1, _ctx.description), ["prevent"]), ["up"])),
                                                        _cache[9] || (_cache[9] = _withKeys(_withModifiers(() => _ctx.navigateSuggestions(1, _ctx.description), ["prevent"]), ["down"]))
                                                    ],
                                                    onBlur: _cache[10] || (_cache[10] = () => _ctx.handleBlur(_ctx.description, _ctx.fieldConfigs.description))
                                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                                _createTextVNode(),
                                                (_ctx.errors.description && _ctx.attemptedSave)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(_ctx.errors.description), 1 /* TEXT */))
                                                    : _createCommentVNode("v-if", true),
                                                _createTextVNode(),
                                                _createCommentVNode(" Suggestions Dropdown "),
                                                _createTextVNode(),
                                                (_ctx.description.showSuggestions)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                                        (_ctx.description.suggestions.length)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.description.suggestions, (suggestion, index) => {
                                                                    return (_openBlock(), _createElementBlock("div", {
                                                                        key: index,
                                                                        class: _normalizeClass(['suggestion-item', { active: index === _ctx.description.selectedIndex }]),
                                                                        onMousedown: _withModifiers(() => _ctx.selectSuggestion(suggestion, _ctx.description, _ctx.fieldConfigs.description), ["prevent"]),
                                                                        onMouseover: ($event) => (_ctx.description.selectedIndex = index)
                                                                    }, _toDisplayString(suggestion), 43 /* TEXT, CLASS, PROPS, NEED_HYDRATION */, _hoisted_47));
                                                                }), 128 /* KEYED_FRAGMENT */))
                                                            ]))
                                                            : (_openBlock(), _createElementBlock("div", _hoisted_48, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tNo matching suggestions\r\n\t\t\t\t\t\t\t\t\t\t\t\t"))
                                                    ]))
                                                    : _createCommentVNode("v-if", true)
                                            ])
                                        ])
                                    ]),
                                    _createTextVNode(),
                                    _createCommentVNode(" Assignee "),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_49, [
                                        _createElementVNode("div", _hoisted_50, [
                                            _hoisted_51,
                                            _createTextVNode(),
                                            _createVNode(_component_multiselect, {
                                                modelValue: _ctx.assigned,
                                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.assigned) = $event)),
                                                name: "assignee",
                                                options: _ctx.users,
                                                "track-by": "value",
                                                label: "text",
                                                searchable: true,
                                                "show-labels": false,
                                                placeholder: "Select assignee",
                                                class: "multiselect-small"
                                            }, null, 8 /* PROPS */, ["modelValue", "options"])
                                        ]),
                                        _createTextVNode(),
                                        _createCommentVNode(" Severity "),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_52, [
                                            _hoisted_53,
                                            _createTextVNode(),
                                            _createVNode(_component_multiselect, {
                                                modelValue: _ctx.severity,
                                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.severity) = $event)),
                                                name: "severity",
                                                options: _ctx.severities,
                                                "track-by": "value",
                                                label: "text",
                                                searchable: true,
                                                "show-labels": false,
                                                placeholder: "Select severity",
                                                class: "multiselect-small"
                                            }, null, 8 /* PROPS */, ["modelValue", "options"])
                                        ])
                                    ]),
                                    _createTextVNode(),
                                    _createCommentVNode(" Action section with stacked options "),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_54, [
                                        _createElementVNode("div", _hoisted_55, [
                                            _hoisted_56,
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_57, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actionOptions, (option) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: option.value,
                                                        class: "issue-action-option"
                                                    }, [
                                                        _createVNode(_component_b_form_radio, {
                                                            modelValue: _ctx.model.action,
                                                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.model.action) = $event)),
                                                            value: option.value
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(option.text), 1 /* TEXT */)
                                                            ]),
                                                            _: 2 /* DYNAMIC */
                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "value"]),
                                                        _createTextVNode(),
                                                        _createCommentVNode(" Task input aligned with Task option "),
                                                        _createTextVNode(),
                                                        (option.value === 2 && _ctx.model.action === 2)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                                                _createElementVNode("div", _hoisted_59, [
                                                                    _createVNode(_component_b_form_input, _mergeProps(_ctx.taskVal, {
                                                                        type: "text",
                                                                        modelValue: _ctx.task.input,
                                                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_ctx.task.input) = $event)),
                                                                        maxlength: "250",
                                                                        class: ['form-control', _ctx.errors && _ctx.errors.task && _ctx.attemptedSave ? 'is-invalid' : ''],
                                                                        placeholder: "Enter task",
                                                                        onInput: _cache[15] || (_cache[15] = (e) => _ctx.handleInput(e, _ctx.task, _ctx.fieldConfigs.task)),
                                                                        onKeydown: [
                                                                            _cache[16] || (_cache[16] = _withKeys(_withModifiers(() => _ctx.handleEnterKey(_ctx.task, _ctx.fieldConfigs.task), ["prevent"]), ["enter"])),
                                                                            _cache[17] || (_cache[17] = _withKeys(() => _ctx.clearSuggestions(_ctx.task), ["tab"])),
                                                                            _cache[18] || (_cache[18] = _withKeys(_withModifiers(() => _ctx.navigateSuggestions(-1, _ctx.task), ["prevent"]), ["up"])),
                                                                            _cache[19] || (_cache[19] = _withKeys(_withModifiers(() => _ctx.navigateSuggestions(1, _ctx.task), ["prevent"]), ["down"]))
                                                                        ],
                                                                        onBlur: _cache[20] || (_cache[20] = () => _ctx.handleBlur(_ctx.task, _ctx.fieldConfigs.task))
                                                                    }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                                                    _createTextVNode(),
                                                                    (_ctx.errors.task && _ctx.attemptedSave)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString(_ctx.errors.task), 1 /* TEXT */))
                                                                        : _createCommentVNode("v-if", true),
                                                                    _createTextVNode(),
                                                                    _createCommentVNode(" Suggestions Dropdown "),
                                                                    _createTextVNode(),
                                                                    (_ctx.task.showSuggestions)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                                                            (_ctx.task.suggestions.length)
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.task.suggestions, (suggestion, index) => {
                                                                                        return (_openBlock(), _createElementBlock("div", {
                                                                                            key: index,
                                                                                            class: _normalizeClass(['suggestion-item', { active: index === _ctx.task.selectedIndex }]),
                                                                                            onMousedown: _withModifiers(() => _ctx.selectSuggestion(suggestion, _ctx.task, _ctx.fieldConfigs.task), ["prevent"]),
                                                                                            onMouseover: ($event) => (_ctx.task.selectedIndex = index)
                                                                                        }, _toDisplayString(suggestion), 43 /* TEXT, CLASS, PROPS, NEED_HYDRATION */, _hoisted_63));
                                                                                    }), 128 /* KEYED_FRAGMENT */))
                                                                                ]))
                                                                                : (_openBlock(), _createElementBlock("div", _hoisted_64, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tNo matching suggestions\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"))
                                                                        ]))
                                                                        : _createCommentVNode("v-if", true)
                                                                ])
                                                            ]))
                                                            : _createCommentVNode("v-if", true),
                                                        _createTextVNode(),
                                                        _createCommentVNode(" Resolved date input aligned with Resolved option "),
                                                        _createTextVNode(),
                                                        (option.value === 3 && _ctx.model.action === 3)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                                                _createVNode(_component_b_input_group, {
                                                                    class: _normalizeClass(['top_search'])
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createVNode(_component_flat_pickr, _mergeProps(_ctx.resolvedVal, {
                                                                            class: ['form-control', { 'is-invalid': _ctx.errors.resolved && _ctx.attemptedSave }],
                                                                            modelValue: _ctx.model.resolved,
                                                                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((_ctx.model.resolved) = $event)),
                                                                            config: _ctx.dateConfig,
                                                                            placeholder: "Select date"
                                                                        }), null, 16 /* FULL_PROPS */, ["class", "modelValue", "config"]),
                                                                        _createTextVNode(),
                                                                        _createVNode(_component_b_input_group_append, null, {
                                                                            default: _withCtx(() => [
                                                                                _hoisted_66
                                                                            ]),
                                                                            _: 1 /* STABLE */
                                                                        })
                                                                    ]),
                                                                    _: 1 /* STABLE */
                                                                })
                                                            ]))
                                                            : _createCommentVNode("v-if", true)
                                                    ]));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ])
                                        ])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_67, [
                                        _createElementVNode("div", _hoisted_68, [
                                            _hoisted_69,
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_70, [
                                                _createVNode(_component_RichTextareaVue, {
                                                    ref: "notesTextarea",
                                                    modelValue: _ctx.model.notes,
                                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((_ctx.model.notes) = $event)),
                                                    class: _normalizeClass(['form-control', _ctx.errors && _ctx.errors.notes && _ctx.attemptedSave ? 'is-invalid' : '']),
                                                    placeholder: "Enter notes"
                                                }, null, 8 /* PROPS */, ["modelValue", "class"]),
                                                _createTextVNode(),
                                                (_ctx.errors.notes && _ctx.attemptedSave)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_71, _toDisplayString(_ctx.errors.notes), 1 /* TEXT */))
                                                    : _createCommentVNode("v-if", true),
                                                _createTextVNode(),
                                                _createElementVNode("div", _hoisted_72, [
                                                    _createVNode(_component_b_button, {
                                                        variant: "link",
                                                        onClick: _ctx.addLink
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _hoisted_73,
                                                            _createTextVNode(" Add Link\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["onClick"])
                                                ])
                                            ])
                                        ])
                                    ]),
                                    _createTextVNode(),
                                    (_ctx.isAdministrator)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                            _createElementVNode("div", _hoisted_75, [
                                                _createVNode(_component_b_form_checkbox, {
                                                    modelValue: _ctx.model.internal,
                                                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((_ctx.model.internal) = $event)),
                                                    size: "lg"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tInternal issue\r\n\t\t\t\t\t\t\t\t\t\t")
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["modelValue"])
                                            ])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    _createVNode(_component_b_modal, {
                                        modelValue: _ctx.linkDialogVisible,
                                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event) => ((_ctx.linkDialogVisible) = $event)),
                                        "header-bg-variant": "normal",
                                        size: "md",
                                        title: "Add Link",
                                        onOk: _ctx.insertLink,
                                        "ok-title": "Insert",
                                        "cancel-title": "Cancel",
                                        onKeyup: _withKeys(_ctx.handleModalEnter, ["enter"])
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_b_form, {
                                                onSubmit: _withModifiers(_ctx.insertLink, ["prevent"])
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_b_form_group, { label: "URL:" }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_b_form_input, {
                                                                modelValue: _ctx.linkDialog.url,
                                                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => ((_ctx.linkDialog.url) = $event)),
                                                                autofocus: "",
                                                                type: "url",
                                                                placeholder: "https://...",
                                                                onKeyup: _cache[25] || (_cache[25] = _withKeys(_withModifiers(() => { }, ["prevent"]), ["enter"]))
                                                            }, null, 8 /* PROPS */, ["modelValue"])
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }),
                                                    _createTextVNode(),
                                                    _createVNode(_component_b_form_group, { label: "Text to display:" }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_b_form_input, {
                                                                modelValue: _ctx.linkDialog.text,
                                                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => ((_ctx.linkDialog.text) = $event)),
                                                                type: "text",
                                                                placeholder: "Link text",
                                                                onKeyup: _cache[27] || (_cache[27] = _withKeys(_withModifiers(() => { }, ["prevent"]), ["enter"]))
                                                            }, null, 8 /* PROPS */, ["modelValue"])
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    })
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["onSubmit"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue", "onOk", "onKeyup"])
                                ])
                            ])
                        ])
                    ])
                ])
            ]),
            _createTextVNode(),
            _createVNode(_component_StatusOverlayComponent, {
                visible: _ctx.working,
                message: "Wait..."
            }, null, 8 /* PROPS */, ["visible"])
        ]))
        : _createCommentVNode("v-if", true);
}
